import { SubscriptionStepFormValues } from "./types";

/** Šifra packa koji se ne može isključiti. */
export const CORE_PACK_CODE = "core";

/** Ključ minimalne mjesečne naknade. */
export const MINIMUM_KEY_CODE = "minimum";

/** Ključ godišnjeg popusta. */
export const ANNUAL_DISCOUNT_KEY_CODE = "popust.godisnji";

/** Ključ trajanja probnog perioda u danima. */
export const TRIAL_DAYS_KEY_CODE = "probni.dana";

/** Današnji datum kao "YYYY-MM-DD" u lokalnoj zoni. */
export const todayAsDateString = (): string => {
  const now = new Date();

  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(
    now.getDate()
  ).padStart(2, "0")}`;
};

/**
 * Prazan korak pretplate. Nijedan iznos ovdje ne postoji — cijene dolaze isključivo iz
 * resolvera, a ovo je samo oblik koji obrazac očekuje.
 */
export const initialSubscriptionStepForm: SubscriptionStepFormValues = {
  packCodes: [CORE_PACK_CODE],
  billingPeriod: "Monthly",
  startsOn: todayAsDateString(),
  pricingSchemeId: null,
  withTrial: true,
  overrides: [],
  estimatedVehicles: null,
  estimatedQuantities: {},
};
